// extracted by mini-css-extract-plugin
module.exports = {"odds":"_2fedc7e","oddsChanged":"_3baa687"};